import React from 'react';
import { Outlet } from 'react-router-dom';

const UnauthenticatedLayout: React.FC = () => (
  <div className="min-h-screen flex items-center justify-center bg-background p-4">
    <Outlet />
  </div>
);

export default UnauthenticatedLayout; 